import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="centered-state">
      <h1>404</h1>
      <p>Page not found.</p>
      <Link to="/dashboard" style={{ color: "var(--text)", textDecoration: "underline" }}>
        Go to dashboard
      </Link>
    </div>
  );
}
